import { z } from 'zod';
export const recentRecordSchema = z.object({
    project_id: z.string().uuid(),
    record_type: z.enum(['lead', 'deal', 'account']),
    record_id: z.string().uuid(),
    title: z.string().min(1).max(200),
});
export const uiStatePatchSchema = z.object({
    dismiss_tooltip: z.string().min(1).max(80).optional(),
    hide_onboarding: z.string().uuid().optional(),
});
export const maintenancePatchSchema = z.object({
    enabled: z.boolean(),
    message: z.string().max(500).optional(),
});
export const featureFlagPatchSchema = z.object({
    flag_key: z.string().min(1).max(80),
    project_id: z.string().uuid().nullable().optional(),
    enabled: z.boolean(),
});
export const consentLogQuerySchema = z.object({
    project_id: z.string().uuid(),
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
export const adminAuditQuerySchema = z.object({
    limit: z.coerce.number().int().min(1).max(200).default(50),
});
//# sourceMappingURL=platform.js.map